<template>
  <w-td class="moving text-center">
    <w-button
      v-if="moveUp"
      ghost
      size="sm"
      icon="move_up"
      aria-label="Przesuń wiersz w górę"
      @click="moveRowUp"
    />

    <w-button
      v-if="moveDown"
      ghost
      size="sm"
      icon="move_down"
      aria-label="Przesuń wiersz w dół"
      @click="moveRowDown"
    />

    <w-button
      v-if="deleteRow"
      ghost
      size="sm"
      color="danger"
      icon="delete"
      aria-label="Usuń wiersz"
      @click="removeRow"
    />
  </w-td>
</template>

<script setup lang="ts">
import type { IArrayItemExt } from '@witkac/jschema';

import { confirmService } from '../../services/confirm.service';

const {
  model,
  confirmDeleteMessage = 'Czy jesteś pewien/a, że chcesz usunąć ten wiersz?',
  deleteRow = true,
  moveUp = true,
  moveDown = true,
} = defineProps<{
  /**
   * Model pojedynczego wiersza tablicy, który będzie modyfikowany przez przyciski akcji. Powinien być typu IArrayItemExt.
   */
  model: IArrayItemExt;

  /**
   * Wiadomość wyświetlana w oknie potwierdzenia przed usunięciem wiersza. Domyślnie "Czy jesteś pewien/a, że chcesz usunąć ten wiersz?".
   */
  confirmDeleteMessage?: string;

  /**
   * Flaga określająca, czy przyciski usuwania i przesuwania wiersza mają być widoczne.
   */
  deleteRow?: boolean;

  /**
   * Flaga określająca, czy przycisk przesuwania wiersza w górę ma być widoczny.
   */
  moveUp?: boolean;

  /**
   * Flaga określająca, czy przycisk przesuwania wiersza w dół ma być widoczny.
   */
  moveDown?: boolean;
}>();

const emit = defineEmits<{
  rowDeleted: [];
  rowMovedUp: [model: IArrayItemExt];
  rowMovedDown: [model: IArrayItemExt];
}>();

function moveRowUp() {
  model.$moveUp();
  emit('rowMovedUp', model);
}

function moveRowDown() {
  model.$moveDown();
  emit('rowMovedDown', model);
}

function removeRow() {
  confirmService
    .confirm(confirmDeleteMessage)
    .then(() => {
      model.$removeRow();
      emit('rowDeleted');
    })
    .catch(() => {
      // Użytkownik anulował usunięcie
    });
}
</script>
